export default "__VITE_ASSET__B73$p7pO__"